// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__T84kS","blur":"Layout_blur__TBpeS","mainContainer":"Layout_mainContainer__2yQVO"};